import { Component, Input, Injector, OnInit, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlValueAccessor } from '../../../../shared/core/base-control-value-accessor';
import { SectionState } from '../../../../shared/components/section/section.model';
import { TypeActeAttaque } from '../../../../entities/type-acte-attaque';
import { SiteJuridiction } from '../../../../entities/site-juridiction';
import { ParametersService } from '../../../../shared/services/parameters.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'jhi-type-acte-attaque-section',
    templateUrl: './type-acte-attaque-section.component.html',
    styleUrls: ['./type-acte-attaque-section.component.scss'],
    providers: [
      {
          provide: NG_VALUE_ACCESSOR,
          useExisting: TypeActeAttaqueSectionComponent,
          multi: true
      }
  ]
})
export class TypeActeAttaqueSectionComponent extends BaseControlValueAccessor implements OnInit, OnDestroy {

    @Input()
    siteJuridiction: SiteJuridiction;

    state: SectionState = {index: 3};

    typeActesAttaques: Array<TypeActeAttaque>;

    typeActeAttaque: TypeActeAttaque;

    typeActeAttaqueCode: string;

    typeActeAttaqueFaqItemRank = '141';

    private subscription: Subscription;

    constructor(injector: Injector, private parametersService: ParametersService) {
        super(injector);
    }

    ngOnInit(): void {
        this.loadTypeActeAttaques();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        super.ngOnDestroy();
    }

    private loadTypeActeAttaques() {
        this.subscription = this.parametersService.getParameters()
            .subscribe(parameters =>
                this.typeActesAttaques = parameters.typeActeAttaques
                .filter(taa => ['AMTRRS' , 'ADGARSPE', 'DARCARLC', 'DMCRVEC', 'DACNCP', 'OUAJOP', 'AUTRES'].includes(taa.code))
            );
    }

    protected modelValueChanged(value: string): void {
        this.typeActeAttaqueCode = value;
        this.typeActeAttaque = this.typeActesAttaques.find(typeActeAttaque => typeActeAttaque.code === value);
    }

    // TODO: Find why this method is not Fired and adapt code
    onTypeActesAttaqueChange(typeActeAttaqueCode: string) {
        this.onChange(this.typeActeAttaque = this.typeActesAttaques.find(typeActeAttaque => typeActeAttaque.code === typeActeAttaqueCode));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/steps/juridiction/type-acte-attaque-section/type-acte-attaque-section.component.ts